import { render, staticRenderFns } from "./LandingScreen.vue?vue&type=template&id=a8cd94da&scoped=true"
import script from "./LandingScreen.vue?vue&type=script&lang=js"
export * from "./LandingScreen.vue?vue&type=script&lang=js"
import style0 from "./LandingScreen.vue?vue&type=style&index=0&id=a8cd94da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cd94da",
  null
  
)

export default component.exports